import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw, Check, RotateCcw } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';

export const ReportRecovery = ({ pid, report, onChanged }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  const resolve = async (action) => {
    if (busy) return;
    if (action !== 'check' && !window.confirm(t(`meetingReports.recovery.${action === 'retry' ? 'retryConfirm' : 'sentConfirm'}`))) return;
    setBusy(true); setError('');
    try {
      const { data } = await api.post(`/admin/prospects/${pid}/meeting-reports/${report.id}/recover`, { action, acknowledged: action !== 'check' });
      onChanged(data);
    } catch (e) { setError(typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : t('meetingReports.actionError')); }
    finally { setBusy(false); }
  };
  return <div className="bg-amber-50 border-l-4 border-amber-500 px-4 py-3 space-y-3" data-testid="report-recovery-panel">
    <p className="text-sm text-amber-900" role="status" data-testid="report-recovery-explanation">{t('meetingReports.recovery.explanation')}</p>
    <div className="flex flex-wrap gap-2">
      <Button size="sm" variant="outline" disabled={busy} onClick={() => resolve('check')} data-testid="report-recovery-check"><RefreshCw className="h-4 w-4 mr-1" />{t('meetingReports.recovery.check')}</Button>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => resolve('confirmed_sent')} className="h-auto min-h-9 whitespace-normal text-left" data-testid="report-recovery-confirm-sent"><Check className="h-4 w-4 mr-1 shrink-0" />{t('meetingReports.recovery.received')}</Button>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => resolve('retry')} className="h-auto min-h-9 whitespace-normal text-left" data-testid="report-recovery-retry"><RotateCcw className="h-4 w-4 mr-1 shrink-0" />{t('meetingReports.recovery.retry')}</Button>
    </div>
    {error && <p role="alert" className="text-xs text-rose-700" data-testid="report-recovery-error">{error}</p>}
  </div>;
};